export const CITIES = [
  { id: 'new-york', name: 'New York', country: 'US', lat: 40.71, lon: -74.01 },
  { id: 'london', name: 'London', country: 'UK', lat: 51.51, lon: -0.13 },
  { id: 'tokyo', name: 'Tokyo', country: 'JP', lat: 35.68, lon: 139.69 },
  { id: 'sydney', name: 'Sydney', country: 'AU', lat: -33.87, lon: 151.21 },
  { id: 'paris', name: 'Paris', country: 'FR', lat: 48.86, lon: 2.35 },
  { id: 'dubai', name: 'Dubai', country: 'AE', lat: 25.20, lon: 55.27 },
  { id: 'singapore', name: 'Singapore', country: 'SG', lat: 1.35, lon: 103.82 },
  { id: 'toronto', name: 'Toronto', country: 'CA', lat: 43.65, lon: -79.38 },
];

const CONDITIONS = [
  { label: 'Sunny', icon: '☀️', bg: 'linear-gradient(135deg, #f6d365, #fda085)' },
  { label: 'Partly Cloudy', icon: '⛅', bg: 'linear-gradient(135deg, #a1c4fd, #c2e9fb)' },
  { label: 'Cloudy', icon: '☁️', bg: 'linear-gradient(135deg, #bdc3c7, #95a5a6)' },
  { label: 'Rainy', icon: '🌧️', bg: 'linear-gradient(135deg, #4facfe, #00f2fe)' },
  { label: 'Stormy', icon: '⛈️', bg: 'linear-gradient(135deg, #434343, #000000)' },
  { label: 'Snowy', icon: '🌨️', bg: 'linear-gradient(135deg, #e6e9f0, #eef1f5)' },
  { label: 'Windy', icon: '💨', bg: 'linear-gradient(135deg, #89f7fe, #66a6ff)' },
  { label: 'Clear Night', icon: '🌙', bg: 'linear-gradient(135deg, #0c3547, #203a43)' },
];

function seededRandom(seed) {
  let s = seed;
  return function () {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

export function generateWeather(cityId) {
  const city = CITIES.find((c) => c.id === cityId);
  if (!city) return null;

  const daySeed = Math.floor(Date.now() / 86400000);
  const rand = seededRandom(daySeed + cityId.charCodeAt(0) * 100);

  const baseTemp = city.lat > 0 ? 25 - Math.abs(city.lat) * 0.3 : 20 + Math.abs(city.lat) * 0.1;
  const temp = Math.round(baseTemp + (rand() - 0.5) * 20);
  const condIndex = Math.floor(rand() * (CONDITIONS.length - 1));
  const condition = CONDITIONS[condIndex];

  const humidity = Math.round(40 + rand() * 50);
  const windSpeed = Math.round(5 + rand() * 30);
  const pressure = Math.round(1000 + rand() * 30);
  const visibility = Math.round(5 + rand() * 15);
  const uvIndex = Math.round(1 + rand() * 10);
  const feelsLike = temp + Math.round((rand() - 0.5) * 6);

  const hourly = Array.from({ length: 24 }, (_, i) => {
    const hRand = seededRandom(daySeed + cityId.charCodeAt(0) * 100 + i * 7);
    const hTemp = temp + Math.round((hRand() - 0.5) * 8);
    const hCond = CONDITIONS[Math.floor(hRand() * CONDITIONS.length)];
    return {
      hour: i,
      temp: hTemp,
      icon: hCond.icon,
      label: hCond.label,
      precipitation: Math.round(hRand() * 100),
    };
  });

  const daily = Array.from({ length: 7 }, (_, i) => {
    const dRand = seededRandom(daySeed + i + cityId.charCodeAt(0) * 50);
    const dHigh = temp + Math.round(dRand() * 6);
    const dLow = temp - Math.round(dRand() * 8);
    const dCond = CONDITIONS[Math.floor(dRand() * CONDITIONS.length)];
    const date = new Date();
    date.setDate(date.getDate() + i);
    return {
      day: date.toLocaleDateString('en-US', { weekday: 'short' }),
      date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      high: dHigh,
      low: dLow,
      icon: dCond.icon,
      label: dCond.label,
      precipitation: Math.round(dRand() * 80),
    };
  });

  return {
    city,
    temp,
    feelsLike,
    condition,
    humidity,
    windSpeed,
    pressure,
    visibility,
    uvIndex,
    hourly,
    daily,
    sunrise: '6:23 AM',
    sunset: '7:45 PM',
    airQuality: Math.round(20 + rand() * 130),
  };
}
